<script lang="ts" setup>
const model = defineModel<number>({ required: true })

defineProps<{
  meta: PaginationDefault
}>()
</script>

<template>
  <div class="flex justify-end pt-4 w-full">
    <Paginator
      :rows="meta.per_page"
      :total-records="meta.total"
      @page="model = $event.page + 1"
    />
  </div>
</template>
